export type RecordsRegisterStatusView = {
  label: string;
  textColor: string;
  backgroundColor: string;
};

const STATUS_VIEW_MAP: Record<string, RecordsRegisterStatusView> = {
  NEW: {
    label: "Новое",
    textColor: "rgba(51, 51, 51, 1)",
    backgroundColor: "rgba(245, 245, 245, 1)",
  },
  UPDATED: {
    label: "Обновлено",
    textColor: "rgba(51, 51, 51, 1)",
    backgroundColor: "rgba(245, 245, 245, 1)",
  },
  APPROVING: {
    label: "На согласовании",
    textColor: "rgba(0, 52, 173, 1)",
    backgroundColor: "rgba(187, 222, 251, 1)",
  },
  APPROVED: {
    label: "Согласовано",
    textColor: "rgba(0, 52, 173, 1)",
    backgroundColor: "rgba(187, 222, 251, 1)",
  },
  SIGNING: {
    label: "На подписании",
    textColor: "rgba(0, 52, 173, 1)",
    backgroundColor: "rgba(187, 222, 251, 1)",
  },
  SIGNED: {
    label: "Подписано",
    textColor: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(67, 160, 71, 1)",
  },
  REJECTED: {
    label: "Отклонено",
    textColor: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(242, 4, 4, 1)",
  },
};

const normalizeStatusKey = (status: string | null | undefined) =>
  (status ?? "").toString().trim().toUpperCase();

export const getRecordsRegisterStatusView = (
  status: string | null | undefined,
): RecordsRegisterStatusView => {
  const key = normalizeStatusKey(status);
  if (STATUS_VIEW_MAP[key]) return STATUS_VIEW_MAP[key];

  // поддержка, если вдруг приходит русская строка
  switch ((status ?? "").toString().trim()) {
    case "Новое":
      return STATUS_VIEW_MAP.NEW;
    case "Обновлено":
      return STATUS_VIEW_MAP.UPDATED;
    case "На согласовании":
      return STATUS_VIEW_MAP.APPROVING;
    case "Согласовано":
      return STATUS_VIEW_MAP.APPROVED;
    case "На подписании":
      return STATUS_VIEW_MAP.SIGNING;
    case "Подписано":
      return STATUS_VIEW_MAP.SIGNED;
    case "Отклонено":
      return STATUS_VIEW_MAP.REJECTED;
    default:
      return {
        label: key || "-",
        textColor: "rgba(51, 51, 51, 1)",
        backgroundColor: "rgba(245, 245, 245, 1)",
      };
  }
};

